import { Button, Sheet } from "../../components/ui";

export function RegenerationConfirm({
  open,
  title,
  description,
  confirmLabel,
  pendingLabel,
  pending,
  error,
  onConfirm,
  onClose,
}: {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  pendingLabel: string;
  pending: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Sheet
      open={open}
      title={title}
      onClose={pending ? () => undefined : onClose}
    >
      <div className="memory-regeneration-confirm">
        <p>{description}</p>
        {error ? (
          <p className="memory-regeneration-confirm__error" role="alert">
            {error}
          </p>
        ) : null}
        <div className="memory-regeneration-confirm__actions">
          <Button tone="quiet" disabled={pending} onClick={onClose}>
            先不改
          </Button>
          <Button tone="primary" disabled={pending} onClick={onConfirm}>
            {pending ? pendingLabel : confirmLabel}
          </Button>
        </div>
      </div>
    </Sheet>
  );
}
